export const handleWindowResize = () => {
  // const bodyMaxWidth = 1366;
  // const remScalingFactor = 50;
  // const fontSize = window.innerWidth >= bodyMaxWidth ? bodyMaxWidth : window.innerWidth;
  //
  // document.documentElement.style.fontSize = '' + fontSize / remScalingFactor + 'px';
}


// WEBPACK FOOTER //
// /usr/src/app/src/utils/helpers.js